<template>
  <div class="cenario-container">
    <div
      :key="`cenarioMercadoriaKey${key}`"
      :class="['cenario-bloco', 'bloco-divisao', { 'bloco-multiplo': numeroCenarios > 1 }]"
    >
      <div v-if="this.dadosForm.tipoOperacao != 41">
        <h3>ORIGEM <span>*</span></h3>
        <CenarioInput
          placeholder="Selecione uma Origem"
          nome="origem"
          :options="filtros.origem_mercadoria.valores.map(p => p.label)"
          :validaCampos="validaCampos"
          :exibeValidacao="exibeValidacao"
          :model="origem"
          @update:model="update => (origem = update)"
          @selected="update => updateDados(update, 'origem', filtros.origem_mercadoria.valores)"
        />
      </div>
      <div v-if="mostraDestinacao">
        <h3>DESTINAÇÃO <span>*</span></h3>
        <CenarioInput
          placeholder="Selecione uma Destinação"
          nome="destinacao"
          :options="tipoDestinacaoOptions"
          :validaCampos="validaCampos"
          :exibeValidacao="exibeValidacao"
          :model="destinacao"
          @update:model="update => (destinacao = update)"
          @selected="update => updateDados(update, 'destinacao', filtros.destinacao.valores)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CenarioInput from "../CenarioInput/CenarioInput.vue";

export default {
  name: "CenarioCorpoMercadoria",

  components: { CenarioInput },

  props: {
    exibeValidacao: Boolean,
    numeroCenarios: Number,
    calculaDadosForm: Function,
    calculaDados: Function,
    dadosForm: Object,
    filtros: Object,
    validaCampos: Object
  },

  data() {
    return {
      origem: "",
      destinacao: "",
      key: 0
    };
  },

  created() {
    this.carregaDadosForm();
    if (this.dadosForm.tipoOperacao == 41) {
      this.origem = "58";
      this.calculaDadosForm("58", "origem");
    } else {
      this.origem = "";
      this.calculaDadosForm("", "origem");
    }
  },

  watch: {
    dadosForm: {
      deep: true,
      handler() {
        if (this.dadosForm.tipoOperacao == 41) {
          this.origem = "58";
          this.calculaDadosForm("58", "origem");
        } else {
          this.origem = "";
          this.calculaDadosForm("", "origem");
        }
      }
    },
    // ZERA O CAMPO DE DESTINAÇÃO QUANDO ALTERA A ATIVIDADE
    "dadosForm.atividadeDestino": {
      deep: true,
      handler() {
        this.destinacao = "";
        this.calculaDadosForm("", "destinacao");
        // this.key += 1;
      }
    },
    // ZERA O CAMPO DE DESTINAÇÃO QUANDO ALTERA O TIPO DE ATIVIDADE
    "dadosForm.tipoAtividade": {
      deep: true,
      handler() {
        this.destinacao = "";
        this.calculaDadosForm("", "destinacao");
        // this.key += 1;
      }
    },
    // ESCREVE NOS INPUTS O VALOR DO FORMULÁRIO QUANDO ALTERADO
    dadosForm: {
      deep: true,
      handler() {
        this.carregaDadosForm();
      }
    }
  },

  computed: {
    // CONDIÇÃO DE EXIBIÇÃO DO INPUT DE DESTINAÇÃO
    mostraDestinacao() {
      if (this.dadosForm.atividadeDestino == "") {
        return false;
      }
      if (this.dadosForm.atividadeDestino == 50 || this.dadosForm.atividadeDestino == 51) {
        return this.dadosForm.tipoAtividade != "" ? true : false;
      }
      return true;
    },
    // RETORNA AS OPÇÕES DE DESTINAÇÃO
    tipoDestinacaoOptions() {
      switch (this.dadosForm.atividadeDestino) {
        case "47":
          let tipo47 = ["24", "19", "20", "26"];
          tipo47.forEach((valor, index) => {
            let filtro = this.filtros.destinacao.valores.find(p => p.value == valor).label;
            tipo47[index] = filtro;
          });
          return tipo47;
        case "48":
          let tipo48 = ["24", "20", "26"];
          tipo48.forEach((valor, index) => {
            let filtro = this.filtros.destinacao.valores.find(p => p.value == valor).label;
            tipo48[index] = filtro;
          });
          return tipo48;
        case "49":
          let tipo49 = ["24", "20", "26"];
          tipo49.forEach((valor, index) => {
            let filtro = this.filtros.destinacao.valores.find(p => p.value == valor).label;
            tipo49[index] = filtro;
          });
          return tipo49;
        case "50":
          let tipo50 = [];
          switch (this.dadosForm.tipoAtividade) {
            case "52":
              tipo50 = ["24", "21", "26"];
              tipo50.forEach((valor, index) => {
                let filtro = this.filtros.destinacao.valores.find(p => p.value == valor).label;
                tipo50[index] = filtro;
              });
              break;
            case "53":
              tipo50 = ["23", "22", "25"];
              tipo50.forEach((valor, index) => {
                let filtro = this.filtros.destinacao.valores.find(p => p.value == valor).label;
                tipo50[index] = filtro;
              });
              break;
            case "54":
              tipo50 = ["27"];
              tipo50.forEach((valor, index) => {
                let filtro = this.filtros.destinacao.valores.find(p => p.value == valor).label;
                tipo50[index] = filtro;
              });
              break;
            case "55":
              tipo50 = ["27"];
              tipo50.forEach((valor, index) => {
                let filtro = this.filtros.destinacao.valores.find(p => p.value == valor).label;
                tipo50[index] = filtro;
              });
              break;
            default:
              break;
          }
          return tipo50;
        case "51":
          let tipo51 = ["24", "19", "26"];
          tipo51.forEach((valor, index) => {
            let filtro = this.filtros.destinacao.valores.find(p => p.value == valor).label;
            tipo51[index] = filtro;
          });
          return tipo51;
        default:
          return [];
      }
    }
  },

  methods: {
    // ATUALIZA O FORMULÁRIO DE ACORDO COM OS VALORES LOCAIS
    updateDados(update, campo, caminho) {
      if (update == "Ativo Imobilizado" && this.dadosForm.tipoAtividade == 53) {
        this[campo] = update;
        this.calculaDadosForm("23", campo);
      } else if (update == "Ativo Imobilizado") {
        this[campo] = update;
        this.calculaDadosForm("24", campo);
      } else {
        this[campo] = update;
        let valor = caminho.find(p => p.label == update);
        this.calculaDadosForm(valor ? valor.value : "", campo);
      }
    },
    // ESCREVE OS VALORES DOS INPUTS DE ACORDO COM O FORMULÁRIO
    carregaDadosForm() {
      let dados = [
        { valor: "origem", filtro: this.filtros.origem_mercadoria.valores },
        { valor: "destinacao", filtro: this.filtros.destinacao.valores }
      ];
      dados.forEach(p => {
        this.carregaValor(p.valor, p.filtro);
      });
    },
    // FUNÇÃO CHAMADA PARA ESCREVER OS VALORES LOCAIS
    carregaValor(valor, filtro) {
      let resultado = filtro.find(p => p.value == this.dadosForm[valor]);
      this[valor] = resultado ? resultado.label : "";
    }
  }
};
</script>

<style lang="scss" scoped>
h3 {
  font-family: "Open Sans";
  font-weight: bold;
  font-size: 11px;
  text-transform: uppercase;
  color: #9ea2a7;
  span {
    color: red;
  }
}
.cenario-container {
  margin: 0.5rem 0;
}
.cenario-bloco {
  margin-top: 10px;
}
.cenario-cnpj {
  display: flex;
}
.sabe-cnpj-input {
  width: 140px;
}
</style>
